export const version = '1.0.0-beta.16';
